<template>
    <div class="page-container">
        <!-- Animated Background -->
        <AnimatedBackground />
        
        <!-- Hero Section -->
        <HeroSection />

        <!-- Features Section -->
        <FeaturesSection />

        <!-- How It Works Section -->
        <HowItWorksSection />

        <!-- Interactive Demo Section -->
        <DemoSection />

        <!-- Pricing Section -->
        <PricingSection />

        <!-- CTA Section -->
        <CTASection />

        <!-- Footer Section -->
        <FooterSection />
    </div>
</template>

<script>
import AnimatedBackground from '@/components/AnimatedBackground.vue';
import HeroSection from '@/components/home/HeroSection.vue';
import FeaturesSection from '@/components/home/FeaturesSection.vue';
import HowItWorksSection from '@/components/home/HowItWorksSection.vue';
import DemoSection from '@/components/home/DemoSection.vue';
import PricingSection from '@/components/home/PricingSection.vue';
import CTASection from '@/components/home/CTASection.vue';
import FooterSection from '@/components/home/FooterSection.vue';

export default {
    name: 'HomeView',
    components: {
        AnimatedBackground,
        HeroSection,
        FeaturesSection,
        HowItWorksSection,
        DemoSection,
        PricingSection,
        CTASection,
        FooterSection
    },
    mounted() {
        this.setupFadeInObserver();
    },
    methods: {
        setupFadeInObserver() {
            const fadeInObserver = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            entry.target.classList.add('is-visible');
                        }
                    });
                },
                {
                    threshold: 0.4,
                    rootMargin: '0px 0px -50px 0px'
                }
            );

            // Observe all fade-in sections
            const fadeElements = document.querySelectorAll('.fade-in-section, .stagger-children');
            fadeElements.forEach((el) => fadeInObserver.observe(el));
        }
    }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@300;400;500;600;700&display=swap');

* {
    font-family: "Space Grotesk", sans-serif;
    font-weight: 400;
    letter-spacing: 1px;
    box-sizing: border-box;
}

.page-container {
    position: relative;
    overflow-x: hidden;
    min-height: 100vh;
    background: var(--bg-primary);
}

/* Scrollbar */
::-webkit-scrollbar {
    width: 12px;
}

::-webkit-scrollbar-track {
    background: var(--bg-primary);
}

::-webkit-scrollbar-thumb {
    background: var(--accent);
    border-radius: 6px;
}

::-webkit-scrollbar-thumb:hover {
    background: #ffd98e;
}

/* Stagger children animations */
.stagger-children > * {
    opacity: 0;
    transform: translateY(20px);
    transition: opacity 0.6s ease-out, transform 0.6s ease-out;
}

.stagger-children.is-visible > * {
    opacity: 1;
    transform: translateY(0);
}

.stagger-children.is-visible > *:nth-child(1) { transition-delay: 0.1s; }
.stagger-children.is-visible > *:nth-child(2) { transition-delay: 0.2s; }
.stagger-children.is-visible > *:nth-child(3) { transition-delay: 0.3s; }
.stagger-children.is-visible > *:nth-child(4) { transition-delay: 0.4s; }
.stagger-children.is-visible > *:nth-child(5) { transition-delay: 0.5s; }
.stagger-children.is-visible > *:nth-child(6) { transition-delay: 0.6s; }
.stagger-children.is-visible > *:nth-child(7) { transition-delay: 0.7s; }
.stagger-children.is-visible > *:nth-child(8) { transition-delay: 0.8s; }
</style>